import {
    EventsInteractionsTracker,
    InteractionsLoggerV1,
    InteractionsLoggerV2,
    InteractionsStatsigLogger,
} from '@eventbrite/event-tracker';

interface TrackingFeatureFlags {
    enableTrackingV2Global: boolean;
    enableRedirectTrackingToV2: boolean;
}

let uniqueEventInteractionTracker: EventsInteractionsTracker;

export function startEventCardsTracking(featureFlags: TrackingFeatureFlags) {
    if (uniqueEventInteractionTracker) {
        return;
    }
    const eventInteractionTracker = new EventsInteractionsTracker(
        document,
        getActiveLoggersBasedOn(featureFlags),
    );
    eventInteractionTracker.listen();
    eventInteractionTracker.track();
    uniqueEventInteractionTracker = eventInteractionTracker;
}

function getActiveLoggersBasedOn(featureFlags: TrackingFeatureFlags) {
    const commonLoggers = [new InteractionsStatsigLogger()];

    if (featureFlags.enableTrackingV2Global) {
        return [
            new InteractionsLoggerV1(),
            new InteractionsLoggerV2(),
            ...commonLoggers,
        ];
    }

    if (featureFlags.enableRedirectTrackingToV2) {
        return [new InteractionsLoggerV2(), ...commonLoggers];
    } else {
        return [new InteractionsLoggerV1(), ...commonLoggers];
    }
}
